// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sidebar_sidebarShell__yBbg5 {
  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 52%, #f4f5fa 100%);
  width: 285px;
  position: fixed;
  top: var(--app-header-height, 60px);
  left: 0;
  bottom: 0;
  padding: 0.625rem 0.1875rem 1.25rem 0;
  border-right: 1px solid #e2e8f0;
  box-shadow: 2px 0 24px rgba(15, 23, 42, 0.04);
  box-sizing: border-box;
  z-index: 998;
  overflow-x: hidden;
  overflow-y: auto;
  transition:
    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.24s ease;
}

.sidebar_sidebarShellNarrow__6CqS0 {
  width: 80px;
  padding-left: 0;
  padding-right: 0.3125rem;
}

.sidebar_contextHeader__5FGQM {
  display: flex;
  align-items: center;
  min-height: 3rem;
  margin-bottom: 0.5rem;
  padding: 0.55rem 0.875rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  background: linear-gradient(to bottom, #ffffff, #f8fafc);
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: -0.015em;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition:
    opacity 0.22s ease,
    max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    margin 0.26s ease,
    padding 0.26s ease,
    border-width 0.2s ease;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_contextHeader__5FGQM {
  opacity: 0;
  max-height: 0;
  min-height: 0;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  padding-top: 0;
  padding-bottom: 0;
  border-width: 0;
  pointer-events: none;
}

.sidebar_contextHeaderLabel__YF\\+x0 {
  overflow: hidden;
  white-space: nowrap;
  transition: opacity 0.2s ease;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_contextHeaderLabel__YF\\+x0 {
  opacity: 0;
}

.sidebar_line__G6uFk {
  display: flex;
  align-items: center;
  margin: 1.1rem 0 0.65rem;
  padding: 0;
  padding-left: 0.0625rem;
  text-transform: uppercase;
  color: #64748b;
  font-size: 0.78125rem;
  font-weight: 600;
  letter-spacing: 0.06em;
  overflow: hidden;
  transition:
    opacity 0.2s ease,
    max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    margin 0.26s ease;
  max-height: 4rem;
}

.sidebar_line__G6uFk::before,
.sidebar_line__G6uFk::after {
  content: "";
  flex-grow: 1;
  height: 1px;
  background: linear-gradient(90deg, transparent, #e2e8f0 18%, #e2e8f0 82%, transparent);
  margin: 0 10px;
}

.sidebar_line__G6uFk:first-child {
  margin-top: 0;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_line__G6uFk {
  opacity: 0;
  max-height: 0;
  margin-top: 0;
  margin-bottom: 0;
  pointer-events: none;
}

.sidebar_sidebarShell__yBbg5 > div:first-child > .sidebar_line__G6uFk:first-child {
  margin-top: 0.65rem;
}

.sidebar_sidebarShellNarrow__6CqS0 > div:first-child > .sidebar_line__G6uFk:first-child {
  margin-top: 0;
}

.sidebar_navItem__JQE4Q {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  min-height: 3.125rem;
  flex-direction: row;
  align-items: center;
  padding: 0.6rem 0.75rem 0.6rem 0.9rem;
  margin-bottom: 0.4rem;
  margin-right: 0.5rem;
  border-radius: 0 10px 10px 0;
  border: 1px solid transparent;
  color: #334155;
  font-size: 1.0625rem;
  font-weight: 500;
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    border-color 0.18s ease,
    box-shadow 0.18s ease,
    color 0.18s ease,
    transform 0.12s ease,
    padding 0.26s cubic-bezier(0.4, 0, 0.2, 1),
    justify-content 0.26s ease;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_navItem__JQE4Q {
  justify-content: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  margin-right: 0.375rem;
}

.sidebar_navItem__JQE4Q:hover:not(.sidebar_navItemSelected__tf8rR) {
  background-color: rgba(241, 245, 249, 0.95);
  border-color: #e2e8f0;
}

.sidebar_navItem__JQE4Q:active {
  transform: scale(0.99);
}

.sidebar_navItem__JQE4Q:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.45);
  border-color: #c7d2fe;
}

.sidebar_navItemSelected__tf8rR {
  background: linear-gradient(
    90deg,
    var(--sb-fade-a, #7376ca),
    var(--sb-fade-b, #6e70c8)
  ) !important;
  border-color: rgba(255, 255, 255, 0.28);
  color: #ffffff !important;
  box-shadow:
    0 2px 8px rgba(55, 48, 163, 0.22),
    0 1px 2px rgba(15, 23, 42, 0.06);
}

.sidebar_navItemSelected__tf8rR:hover {
  background: linear-gradient(
    90deg,
    var(--sb-fade-a, #7376ca),
    var(--sb-fade-b, #6e70c8)
  ) !important;
  filter: brightness(1.03);
  border-color: rgba(255, 255, 255, 0.35);
}

.sidebar_navItemText__ZGIiE {
  overflow: hidden;
  white-space: nowrap;
  opacity: 1;
  max-width: 220px;
  transition:
    opacity 0.22s ease,
    max-width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    margin 0.22s ease;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_navItemText__ZGIiE {
  opacity: 0;
  max-width: 0;
  margin-left: 0;
}

.sidebar_sidebarShellNarrow__6CqS0 .sidebar_navItem__JQE4Q svg {
  padding-right: 0 !important;
}

.sidebar_navIcon__kmwSj {
  flex-shrink: 0;
  width: 1.5rem;
  text-align: center;
  opacity: 0.9;
  font-size: 1.125rem;
}

.sidebar_navItemSelected__tf8rR .sidebar_navIcon__kmwSj {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/providers/components/sidebar/sidebar.module.css"],"names":[],"mappings":"AAAA;EACE,0EAA0E;EAC1E,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,OAAO;EACP,SAAS;EACT,qCAAqC;EACrC,+BAA+B;EAC/B,6CAA6C;EAC7C,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB;;;yBAGuB;AACzB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,wDAAwD;EACxD,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,4CAA4C;EAC5C,gBAAgB;EAChB;;;;;0BAKwB;AAC1B;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,UAAU;EACV,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB;;;qBAGmB;EACnB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,sFAAsF;EACtF,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,aAAa;EACb,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qCAAqC;EACrC,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,6BAA6B;EAC7B,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf;;;;;;;8BAO4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,qBAAqB;AACvB;;AAEA;EACE;;;;cAIY;EACZ,uCAAuC;EACvC,yBAAyB;EACzB;;oCAEkC;AACpC;;AAEA;EACE;;;;cAIY;EACZ,wBAAwB;EACxB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB;;;qBAGmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".sidebarShell {\n  background: linear-gradient(180deg, #f8fafc 0%, #f1f5f9 52%, #f4f5fa 100%);\n  width: 285px;\n  position: fixed;\n  top: var(--app-header-height, 60px);\n  left: 0;\n  bottom: 0;\n  padding: 0.625rem 0.1875rem 1.25rem 0;\n  border-right: 1px solid #e2e8f0;\n  box-shadow: 2px 0 24px rgba(15, 23, 42, 0.04);\n  box-sizing: border-box;\n  z-index: 998;\n  overflow-x: hidden;\n  overflow-y: auto;\n  transition:\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    box-shadow 0.24s ease;\n}\n\n.sidebarShellNarrow {\n  width: 80px;\n  padding-left: 0;\n  padding-right: 0.3125rem;\n}\n\n.contextHeader {\n  display: flex;\n  align-items: center;\n  min-height: 3rem;\n  margin-bottom: 0.5rem;\n  padding: 0.55rem 0.875rem;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n  background: linear-gradient(to bottom, #ffffff, #f8fafc);\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  color: #0f172a;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: -0.015em;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  transition:\n    opacity 0.22s ease,\n    max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    margin 0.26s ease,\n    padding 0.26s ease,\n    border-width 0.2s ease;\n}\n\n.sidebarShellNarrow .contextHeader {\n  opacity: 0;\n  max-height: 0;\n  min-height: 0;\n  margin-bottom: 0;\n  margin-left: 0;\n  margin-right: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  border-width: 0;\n  pointer-events: none;\n}\n\n.contextHeaderLabel {\n  overflow: hidden;\n  white-space: nowrap;\n  transition: opacity 0.2s ease;\n}\n\n.sidebarShellNarrow .contextHeaderLabel {\n  opacity: 0;\n}\n\n.line {\n  display: flex;\n  align-items: center;\n  margin: 1.1rem 0 0.65rem;\n  padding: 0;\n  padding-left: 0.0625rem;\n  text-transform: uppercase;\n  color: #64748b;\n  font-size: 0.78125rem;\n  font-weight: 600;\n  letter-spacing: 0.06em;\n  overflow: hidden;\n  transition:\n    opacity 0.2s ease,\n    max-height 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    margin 0.26s ease;\n  max-height: 4rem;\n}\n\n.line::before,\n.line::after {\n  content: \"\";\n  flex-grow: 1;\n  height: 1px;\n  background: linear-gradient(90deg, transparent, #e2e8f0 18%, #e2e8f0 82%, transparent);\n  margin: 0 10px;\n}\n\n.line:first-child {\n  margin-top: 0;\n}\n\n.sidebarShellNarrow .line {\n  opacity: 0;\n  max-height: 0;\n  margin-top: 0;\n  margin-bottom: 0;\n  pointer-events: none;\n}\n\n.sidebarShell > div:first-child > .line:first-child {\n  margin-top: 0.65rem;\n}\n\n.sidebarShellNarrow > div:first-child > .line:first-child {\n  margin-top: 0;\n}\n\n.navItem {\n  user-select: none;\n  display: flex;\n  min-height: 3.125rem;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.6rem 0.75rem 0.6rem 0.9rem;\n  margin-bottom: 0.4rem;\n  margin-right: 0.5rem;\n  border-radius: 0 10px 10px 0;\n  border: 1px solid transparent;\n  color: #334155;\n  font-size: 1.0625rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition:\n    background-color 0.18s ease,\n    border-color 0.18s ease,\n    box-shadow 0.18s ease,\n    color 0.18s ease,\n    transform 0.12s ease,\n    padding 0.26s cubic-bezier(0.4, 0, 0.2, 1),\n    justify-content 0.26s ease;\n}\n\n.sidebarShellNarrow .navItem {\n  justify-content: center;\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  margin-right: 0.375rem;\n}\n\n.navItem:hover:not(.navItemSelected) {\n  background-color: rgba(241, 245, 249, 0.95);\n  border-color: #e2e8f0;\n}\n\n.navItem:active {\n  transform: scale(0.99);\n}\n\n.navItem:focus-visible {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.45);\n  border-color: #c7d2fe;\n}\n\n.navItemSelected {\n  background: linear-gradient(\n    90deg,\n    var(--sb-fade-a, #7376ca),\n    var(--sb-fade-b, #6e70c8)\n  ) !important;\n  border-color: rgba(255, 255, 255, 0.28);\n  color: #ffffff !important;\n  box-shadow:\n    0 2px 8px rgba(55, 48, 163, 0.22),\n    0 1px 2px rgba(15, 23, 42, 0.06);\n}\n\n.navItemSelected:hover {\n  background: linear-gradient(\n    90deg,\n    var(--sb-fade-a, #7376ca),\n    var(--sb-fade-b, #6e70c8)\n  ) !important;\n  filter: brightness(1.03);\n  border-color: rgba(255, 255, 255, 0.35);\n}\n\n.navItemText {\n  overflow: hidden;\n  white-space: nowrap;\n  opacity: 1;\n  max-width: 220px;\n  transition:\n    opacity 0.22s ease,\n    max-width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    margin 0.22s ease;\n}\n\n.sidebarShellNarrow .navItemText {\n  opacity: 0;\n  max-width: 0;\n  margin-left: 0;\n}\n\n.sidebarShellNarrow .navItem svg {\n  padding-right: 0 !important;\n}\n\n.navIcon {\n  flex-shrink: 0;\n  width: 1.5rem;\n  text-align: center;\n  opacity: 0.9;\n  font-size: 1.125rem;\n}\n\n.navItemSelected .navIcon {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sidebarShell": `sidebar_sidebarShell__yBbg5`,
	"sidebarShellNarrow": `sidebar_sidebarShellNarrow__6CqS0`,
	"contextHeader": `sidebar_contextHeader__5FGQM`,
	"contextHeaderLabel": `sidebar_contextHeaderLabel__YF+x0`,
	"line": `sidebar_line__G6uFk`,
	"navItem": `sidebar_navItem__JQE4Q`,
	"navItemSelected": `sidebar_navItemSelected__tf8rR`,
	"navItemText": `sidebar_navItemText__ZGIiE`,
	"navIcon": `sidebar_navIcon__kmwSj`
};
export default ___CSS_LOADER_EXPORT___;
